import type { Fetcher } from "../fetcher";
import type { ApiSingleResponse } from "../types/api";
import type { AskAssistantDto, AssistantReply } from "./types";

/**
 * Repository for the AI support assistant. One endpoint: send a message
 * (plus optional recent history) and get a scoped reply. The server owns the
 * system prompt, guard, and tools; the client just relays the conversation.
 */
export function createAssistantRepository(fetcher: Fetcher) {
  return {
    ask: async (dto: AskAssistantDto): Promise<AssistantReply> => {
      const res = await fetcher<ApiSingleResponse<AssistantReply>>(
        "/assistant/messages",
        {
          method: "POST",
          body: JSON.stringify(dto),
          headers: { "Content-Type": "application/json" },
        },
      );
      return res.data;
    },
  };
}
